import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { pluginFactory, pmHistoryPluginKey } from '@atlaskit/editor-common/utils';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
import reducer from './reducer';
var pluginKey = new PluginKey('mediaAltTextPlugin');
var _pluginFactory = pluginFactory(pluginKey, reducer, {
    onSelectionChanged: function onSelectionChanged(tr, newState) {
      // dont close alt text for undo/redo transactions (if it comes from prosemirror-history)
      if (tr.getMeta(pmHistoryPluginKey)) {
        return newState;
      }
      return {
        isAltTextEditorOpen: false
      };
    }
  }),
  createPluginState = _pluginFactory.createPluginState,
  createCommand = _pluginFactory.createCommand,
  getPluginState = _pluginFactory.getPluginState;
export var createPlugin = function createPlugin(_ref) {
  var dispatch = _ref.dispatch,
    providerFactory = _ref.providerFactory;
  return new SafePlugin({
    state: createPluginState(dispatch, {
      isAltTextEditorOpen: false
    }),
    key: pluginKey
  });
};
export { createCommand, getPluginState };